import React, { useState } from 'react';


const Technologies = () => {
  const [activeTab, setActiveTab] = useState('all');

  const allTechnologies = [
    { name: ".NET Core", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg", category: "backend" },
    { name: "PHP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg", category: "backend" },
    { name: "VB.NET", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/visualstudio/visualstudio-plain.svg", category: "frontend" },
    { name: "ReactJs", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", category: "frontend" },
    { name: "Express.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg", category: "backend" },
    { name: "MS SQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg", category: "database" },
    { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg", category: "backend" },
    { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg", category: "database" },
    { name: "Flutter", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg", category: "frontend" },
    { name: "Android Studio", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/androidstudio/androidstudio-original.svg", category: "frontend" },
    { name: "Azure", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg", category: "backend" },
    { name: "Oracle", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/oracle/oracle-original.svg", category: "database" },
    { name: "Figma", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg", category: "frontend" },
    { name: "Bootstrap", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg", category: "frontend" },
    { name: "Next.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg", category: "frontend" },
    { name: "Tailwind CSS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg", category: "frontend" },
    { name: "React Native", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", category: "frontend" },
    { name: "IBM DB2", icon: "/assets/img/ibm.png", category: "database" }
  ];

  const filteredTechnologies = activeTab === 'all'
    ? allTechnologies
    : allTechnologies.filter(tech => tech.category === activeTab);

  return (
    <div className="tech-universe">
      {/* Animated Background */}
      <div className="tech-bg-animation">
        <div className="tech-orb tech-orb-1"></div>
        <div className="tech-orb tech-orb-2"></div>
        <div className="tech-orb tech-orb-3"></div>
      </div>

      <div className="tech-container-main">
        {/* Header Section */}
        <div className="tech-header-section">
          <div className="tech-title-wrapper">
            <span className="tech-badge">Our Stack</span>
            <h1 className="tech-main-heading">
              Technologies & <span className="tech-gradient-text">Tools</span>
            </h1>
            <p className="tech-description">
              Cutting-edge technologies powering innovative solutions
            </p>
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="tech-filter-section">
          <div className="tech-filter-wrapper">
            <button
              className={`tech-filter-btn ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              All
            </button>
            <button
              className={`tech-filter-btn ${activeTab === 'frontend' ? 'active' : ''}`}
              onClick={() => setActiveTab('frontend')}
            >
              Frontend
            </button>
            <button
              className={`tech-filter-btn ${activeTab === 'backend' ? 'active' : ''}`}
              onClick={() => setActiveTab('backend')}
            >
              Backend
            </button>
            <button
              className={`tech-filter-btn ${activeTab === 'database' ? 'active' : ''}`}
              onClick={() => setActiveTab('database')}
            >
              Database
            </button>
          </div>
        </div>

        {/* Technology Cards Grid */}
        <div className="tech-cards-grid">
          {filteredTechnologies.map((tech, index) => (
            <div
              key={`${tech.name}-${index}`}
              className="tech-card-unique"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="tech-card-glow"></div>
              <div className="tech-card-border"></div>
              <div className="tech-card-content-wrapper">
                <div className="tech-icon-wrapper">
                  <div className="tech-icon-bg"></div>
                  <img
                    src={tech.icon}
                    alt={tech.name}
                    className={`tech-icon-img ${tech.name === 'IBM DB2' ? 'tech-icon-ibm' : ''}`}
                  />
                  <div className="tech-icon-ring"></div>
                </div>
                <h3 className="tech-card-title">{tech.name}</h3>
              </div>
              <div className="tech-card-shine"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Technologies;